import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import styled from "@emotion/styled";

const StyledSkeletonContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
}));

export function FoldersFiltersSkeleton() {
    const theme = useTheme();

    return (
        <StyledSkeletonContainer>
            <Skeleton variant={"rectangular"} height={theme.spacing(2)} width={"100%"} />
            <Skeleton variant={"rectangular"} height={theme.spacing(2)} width={"100%"} />
            <Skeleton variant={"rectangular"} height={theme.spacing(2)} width={"100%"} />
            <Skeleton variant={"rectangular"} height={theme.spacing(2)} width={"100%"} />
            <Skeleton variant={"rectangular"} height={theme.spacing(2)} width={"100%"} />
        </StyledSkeletonContainer>
    );
}

export default FoldersFiltersSkeleton;
